<div class="d-flex">
    <div class="col-4 pl-0 pr-0 phone-picker">
        <ng-select [items]="currencyCodes | async" [formControl]="formControl.get(currencyKey)"
            [formlyAttributes]="field" bindLabel="display_name" bindValue="code" [required]="to.required">
            <ng-template ng-label-tmp let-item="item">
                <!-- <span class="flag flag-{{item.icon}}"></span> -->
                <span>{{item.code}}</span>
            </ng-template>
        </ng-select>
    </div>
    <div class="col-8 pl-0 d-flex flex-column">
        <input type="number" class="form-control form-control-sm"
            [ngClass]="{ 'is-invalid':amountControl.invalid && amountControl.touched }" [required]="to.required"
            [formControl]="formControl.get(amount)" [formlyAttributes]="field">
        <div *ngIf="amountControl.invalid && amountControl.touched" class="invalid-feedback flex-grow">
            <div *ngIf="formControl.get(amount).invalid">This field is required</div>
        </div>
    </div>

</div>